<template>
  <section class="section">
    <div class="container" style="margin-top: 120px;">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <div class="box-style line-top">
            <div class="box-body">
              <div class="bird">
                <img src="/images/bird.png" alt="Andalepide">
              </div>
              <div class="box-text centered margin-top-60" v-if="invitadoData">
                <h1 class="open size-22 margin-bottom-40 txt-black">Bienvenido <span id="user_name" class="regular">{{invitadoData.firstName}} {{invitadoData.lastName}}</span> a <span class="black">andalepide!</span></h1>
                <h1 class="open size-18 margin-bottom-10 txt-black">Te pediremos unos datos más y estarás listo</h1>
              </div>	
              <div class="clear-sm"></div>
              <form class="form smart-form" v-if="invitadoData && !invitadoData.idUsuario">
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group" v-if="invitadoData">
                      <label>Empresa</label>
                      <div class="input-text">{{invitadoData.referidor.sucursalAsociada.empresa.razonSocial}} - {{invitadoData.referidor.sucursalAsociada.denominacion}}</div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Área de la empresa</label>
                      <div class="select">
                        <select>
                          <option value="">Elija...</option>
                          <option value="">Administración</option>
                          <option value="">Atención al cliente</option>
                          <option value="">Comercial</option>
                          <option value="">Contaduría</option>
                          <option value="">Recepción</option>
                          <option value="">RRHH</option>
                          <option value="">Comercial</option>
                          
                        </select>
                        <i class="fa fa fa-angle-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Nombre</label>
                      <input type="text" v-model="userData.firstName" class="form-control">
                      <span class="label label-danger" v-if="!$v.userData.firstName.required && mostrarErrores">El nombre es requerido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Apellido</label>
                      <input type="text" v-model="userData.lastName" class="form-control">
                      <span class="label label-danger" v-if="!$v.userData.lastName.required && mostrarErrores">El apellido es requerido</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>E-mail</label>
                      <input type="mail" v-model="userData.email" class="form-control">
                      <span class="label label-danger" v-if="!$v.userData.email.required && mostrarErrores">El email es requerido</span>
                      <span class="label label-danger" v-if="!$v.userData.email.email && mostrarErrores">Formato de email no válido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Teléfono</label>
                      <input type="text" v-model="userData.telefono" class="form-control">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Password</label>
                      <input type="password" v-model="userData.password" class="form-control">
                      <span class="label label-danger" v-if="!$v.userData.password.required && mostrarErrores">El password es requerido</span>
                      <span class="label label-danger" v-if="!$v.userData.password.minLength && mostrarErrores">El password debe contener 6 caracteres como mínimo</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label>Repetir password</label>
                      <input type="password" v-model="userData.repetirPassword" class="form-control">
                      <span class="label label-danger" v-if="!$v.userData.repetirPassword.sameAs && mostrarErrores">No coincide con el password</span>
                    </div>
                  </div>
                </div>
                <div class="form-action text-center">
                  <button type="button" class="btn btn-fill btn-lg size-16" @click.prevent="guardar">GUARDAR Y COMENZAR</button>
                </div>
              </form>
              <div class="row" v-else>
                <h1 class="text-center center-block">La invitación ya fue utilizada para crear una cuenta</h1>
                <div class="text-center center-block">
                  <router-link to="/login" class="btn btn-fill">Accede ahora a tu cuenta</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {minLength, required, email, sameAs} from 'vuelidate/lib/validators'
  export default {
    created () {
      const me = this
      me.idInvitado = me.$route.params.id
    },
    validations: {
      userData: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required,
          minLength: minLength(6)
        },
        repetirPassword: {
          sameAs: sameAs('password')
        }
      }
    },
    data () {
      return {
        mostrarErrores: false,
        userData: {
          firstName: '',
          lastName: '',
          area: '',
          email: '',
          telefono: '',
          password: '',
          repetirPassword: '',
          idUsuario: null
        },
        idInvitado: null,
        invitadoData: null
      }
    },
    methods: {
      guardar () {
        const me = this
        me.mostrarErrores = false
        if (me.$v.userData.$invalid) {
          me.mostrarErrores = true
          return false
        }
        let data = me.userData
        data.idInvitado = me.idInvitado
        me.$http.post('/api/users/invitados', data).then(({body}) => {
          me.$emit('mostrar-notificacion', 'El usuario se creó correctamente', 'success')
          me.$router.push({
            path: '/login',
            props: {
              user: me.user
            }
          })
        }, (err) => {
          console.error(err)
        })
      }
    },
    mounted () {
      const me = this
      if (me.idInvitado) {
        me.$http.get('/api/users/invitados/', {
          params: {
            id: me.idInvitado
          }
        }).then(({body}) => {
          me.invitadoData = body.invitado
          me.userData.firstName = me.invitadoData.firstName
          me.userData.lastName = me.invitadoData.lastName
          me.userData.email = me.invitadoData.email
        }, (err, par2) => {
          console.error(err, par2)
        })
      } else {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// RegistroInvitado.vue?4448b365